// ── IMAGE SLOTS (Team Meeting Ready) ────────────────────────────────
// Hosted in the Impultienda store resources and ebook covers.
const STORE = 'f0df0607-92e2-4d1f-aa4b-4d01bfd0e5b1';
const RES = `https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/${STORE}/`;
const COVER = (id: string) =>
  `https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/render/image/public/ebook-images/${STORE}/${id}-mockup.webp?width=720&quality=85&resize=contain`;

/** iMac + 3 tablets + 2 phones mockup, one bonus per device. Pure white background: always show it on bg-white. */
const IMAC = RES + '1792582445605_mockup-imac-3tablets-2celus-fondo-blanco-ba300cc9.webp';
export const heroMockupUrl = IMAC;
export const offerMockupUrl = IMAC;
/** Real pages of the PDF (4:5), in the same order as lookInside.captions: p.4, 8, 9, 10, 38, 39. */
export const pageImages: string[] = [
  RES + '1792587257103_pagina-04-plan-q1-cf130415.webp',
  RES + '1792587261271_pagina-08-plan-reunion-5aac74b3.webp',
  RES + '1792587265778_pagina-09-actividad-4624837d.webp',
  RES + '1792587270297_pagina-10-discuss-close-24b5f380.webp',
  RES + '1792587274727_pagina-38-off-track-cadfa529.webp',
  RES + '1792587278796_pagina-39-planner-7571066a.webp',
];
/** 5 bonus covers, in the same order as bonuses (and as the checkout) */
export const bonusCovers: string[] = [
  COVER('393f2666-a6d8-44aa-823f-ef6e65d7cbb0'),
  COVER('fa4494dd-3692-4ff3-bba5-7711058f2f39'),
  COVER('0bfed792-15cc-4ff7-9ea1-eea2d8fd6406'),
  COVER('e5ce4c87-abc7-48ac-8f48-71e880acb37d'),
  COVER('1dfbb032-d40a-4ca5-86ef-b834522bc16f'),
];
